module.exports = __webpack_public_path__ + "_assets/img/page-empty-content.b45a891a.svg";